import { render } from "./addRecord.vue?vue&type=template&id=4cec40f8&scoped=true"
import script from "./addRecord.vue?vue&type=script&lang=js"
export * from "./addRecord.vue?vue&type=script&lang=js"

import "./addRecord.vue?vue&type=style&index=0&id=4cec40f8&scoped=true&lang=css"

import exportComponent from "F:\\Program\\JAVA\\JavaProject\\DXD物流系统\\logisticsWeb\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cec40f8"]])

export default __exports__